import { PermissionCode } from "../redux/features/settings/settings.type";

export const usePermissions = () => {
  const hasPermissionsFor = (
    requiredPermissions: PermissionCode[],
    userPermissions: PermissionCode[] = [],
    mode: "all" | "some" = "some"
  ) => {
    return mode === "all"
      ? requiredPermissions.every((val) => userPermissions.includes(val))
      : requiredPermissions.some((val) => userPermissions.includes(val));
  };

  return { hasPermissionsFor };
};
